import { Component, OnInit, Input, Inject } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { TranslateService } from '@ngx-translate/core';
import { DOCUMENT } from '@angular/common';
import { AuthService } from '../../services/auth.service';
import { LayoutService } from '../../services/layout.service';
// import { DhhpAlertComponent } from '../../../shared/dhhpalert/dhhpalert.component';

@Component({
  selector: 'app-application',
  templateUrl: './application.component.html',
  styleUrls: ['./application.component.scss']
})
export class ApplicationComponent implements OnInit {
  adminEndpointAPI = environment.PLATFORM_AUTH;
  platformURLDash = environment.PLATFORM_Redirect;
  clientID = environment.ClientId;
  loginID: string;
  subscribeAlert: boolean = false;
  appName: string;
  appStatus: string;
  clientSecret = environment.ClientSecret;
  clientData = { clientId: this.clientID, clientSecret: this.clientSecret };
  APISingnature = "AppManager/GetAppManagerByUser/";
  pinpoint = environment.API_ENDPOINT_PLATFORM;
  emitData: any;
  @Input() RightNavData: any;

  constructor(
    private translate: TranslateService,
    @Inject(DOCUMENT) private document: Document,
    private auth: AuthService,
    private layoutService: LayoutService,
    // private dhhpAlert: DhhpAlertComponent
  ) { }

  ngOnInit() {
    this.APISingnature = this.APISingnature + this.auth.getUserToken();
    this.loginID = this.auth.getUserToken();
  }
  getMainPanel(app: string, url: string) {
    this.document.location.href = environment.applicationURL;

  }

  righNavClose() {
    this.RightNavData.toggle();
  }
  onEmitEvent(event) {
    switch (event.event) {
      case 'addPinData':
        // this.dhhpAlert.dhhpAlertConfirmation('Pinned from Dashboard successfully', '');
        this.layoutService.reloadPin.next(true);
        break;
      case 'removePinData':
        this.layoutService.reloadPin.next(true);
        // this.dhhpAlert.dhhpAlertConfirmation('Unpinned from Dashboard successfully', '')
        break;
      case 'subscribeAlert':
        // this.dhhpAlert.dhhpAlertError(event.val, '')
        break;
    }
  }
}
